document.addEventListener('DOMContentLoaded', function () {
  const wrappers = document.querySelectorAll('.custom-header-search');

  wrappers.forEach((wrapper) => {
    const form = wrapper.querySelector('.custom-header-search__form');
    const input = wrapper.querySelector('.custom-header-search__input');
    const results = wrapper.querySelector('.custom-header-search__results');

    if (!form || !input || !results) return;

    let controller = null;
    let debounceTimer = null;

    const closeResults = () => {
      results.classList.remove('is-active');
      results.innerHTML = '';
    };

    const openResults = () => {
      results.classList.add('is-active');
    };

    const escapeHtml = (str) => {
      const div = document.createElement('div');
      div.textContent = str || '';
      return div.innerHTML;
    };

    const renderResults = (products) => {
      if (!products.length) {
        results.innerHTML = `<div class="custom-header-search__empty">No products found.</div>`;
        openResults();
        return;
      }

      const items = products.map((product) => {
        const image = product.featured_image
          ? `<img class="custom-header-search__result-image" src="${product.featured_image.url}&width=120" alt="${escapeHtml(product.title)}">`
          : `<div class="custom-header-search__result-image"></div>`;

        const price = product.price
          ? `<div class="custom-header-search__result-price">${product.price}</div>`
          : '';

        return `
          <a href="${product.url}" class="custom-header-search__result-item">
            ${image}
            <div>
              <div class="custom-header-search__result-title">${escapeHtml(product.title)}</div>
              ${price}
            </div>
          </a>
        `;
      }).join('');

      results.innerHTML = `<div class="custom-header-search__results-inner">${items}</div>`;
      openResults();
    };

    const fetchResults = async (query) => {
      if (controller) controller.abort();
      controller = new AbortController();

      results.innerHTML = `<div class="custom-header-search__loading">Searching...</div>`;
      openResults();

      try {
        const response = await fetch(
          `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`,
          { signal: controller.signal }
        );

        if (!response.ok) throw new Error('Search request failed');

        const data = await response.json();
        const products = data.resources?.results?.products || [];
        renderResults(products);
      } catch (error) {
        if (error.name === 'AbortError') return;
        results.innerHTML = `<div class="custom-header-search__empty">Unable to load results.</div>`;
        openResults();
      }
    };

    input.addEventListener('input', function () {
      const query = input.value.trim();

      clearTimeout(debounceTimer);

      if (query.length < 2) {
        closeResults();
        return;
      }

      debounceTimer = setTimeout(() => {
        fetchResults(query);
      }, 180);
    });

    document.addEventListener('click', function (event) {
      if (!wrapper.contains(event.target)) {
        closeResults();
      }
    });

    input.addEventListener('focus', function () {
      if (results.innerHTML.trim() !== '') {
        openResults();
      }
    });
  });
});